<template lang="pug">
    .cms-disabled-banner(v-if="isVisible")
        i.el-icon-fa-exclamation-circle.fas.cms-disabled-banner__icon
        .cms-disabled-banner__text
            span.cms-disabled-banner__title {{ $t('This web project is currently disabled') }}
            span(v-if="reason")  &mdash; {{ $t(reason) }}
        el-button(v-if="isOwner" type="danger" size="mini" @click="goToBilling")
            | {{ $t('Go to billing settings') }}
        span.cms-disabled-banner__contact(v-else) {{ $t('Please contact the project owner.') }}
</template>

<i18n>
{
    "de": {
        "This web project is currently disabled": "Dieses Webprojekt ist derzeit deaktiviert",
        "Go to billing settings": "Zu den Abrechnungseinstellungen",
        "Please contact the project owner.": "Bitte kontaktieren Sie den Projektinhaber.",
        "trial_expired_no_billing": "Der Testzeitraum ist abgelaufen und es wurde kein Zahlungsmittel hinterlegt.",
        "billing_failed": "Die Abrechnung ist fehlgeschlagen.",
        "manually_disabled": "Das Projekt wurde manuell deaktiviert."
    },
    "en": {
        "trial_expired_no_billing": "The trial period has expired and no payment method was provided.",
        "billing_failed": "Billing has failed.",
        "manually_disabled": "The project was manually disabled."
    }
}
</i18n>

<script>
import { useAuthStore, useSettingsStore, useSetupStore } from '@/stores'
import router from '@/router'

export default {
    name: 'CmsDisabledBanner',
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        isOwner() {
            return useAuthStore().isOwner
        },
        isVisible() {
            return this.activeCms && this.activeCms.is_disabled
        },
        reason() {
            return this.activeCms && this.activeCms.disabled_reason
        },
    },
    methods: {
        goToBilling() {
            useSettingsStore().reset()
            useSettingsStore().setFormInitialized(false)
            router.push({ name: 'settings-billing', params: { id: undefined } })
        },
    },
}
</script>

<style lang="sass" scoped>
.cms-disabled-banner
    background: #fef2f2
    border: 1px solid #fde8e8
    border-radius: 4px
    padding: 10px 16px
    margin: 0 0 25px 0
    display: flex
    align-items: center
    gap: 10px
    font-size: 13px
    line-height: 1.4
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)

    &__icon
        color: #F56C6C
        font-size: 16px
        flex-shrink: 0

    &__text
        flex: 1
        color: #F56C6C

    &__title
        font-weight: 600

    &__contact
        color: #909399
        font-size: 12px
        white-space: nowrap
</style>
